import { defineMessages } from 'react-intl';
import { AccountType, OwnershipType } from '@algoan/dashboard/model';

export const accountMessages = defineMessages({
  [AccountType.CHECKING]: {
    id: 'widgets.bank_history.filter.account_checkings',
    defaultMessage: 'Checkings {index}',
    description: 'Fallback label when account does not have a name',
  },
  [AccountType.SAVINGS]: {
    id: 'widgets.bank_history.filter.account_savings',
    defaultMessage: 'Savings {index}',
    description: 'Fallback label when account does not have a name',
  },
  [AccountType.LOAN]: {
    id: 'widgets.bank_history.filter.account_loan',
    defaultMessage: 'Loan {index}',
    description: 'Fallback label when account does not have a name',
  },
  [AccountType.CREDIT_CARD]: {
    id: 'widgets.bank_history.filter.account_credit_card',
    defaultMessage: 'Credit card {index}',
    description: 'Fallback label when account does not have a name',
  },
  [AccountType.UNKNOWN]: {
    id: 'widgets.bank_history.filter.account_unknown',
    defaultMessage: 'Unknown account {index}',
    description: 'Fallback label when account does not have a name',
  },
  accountNumber: {
    id: 'widgets.bank_statements.account_filter.account_number',
    defaultMessage: 'Account No',
    description: 'Label for account number',
  },
});

export const accountOwnershipMessages = defineMessages({
  [OwnershipType.HOLDER]: {
    id: 'widgets.bank_statements.account_ownership.HOLDER',
    defaultMessage: 'Holder',
    description: 'Label for the account ownership when the customer is the holder',
  },
  [OwnershipType.CO_HOLDER]: {
    id: 'widgets.bank_statements.account_ownership.CO_HOLDER',
    defaultMessage: 'Co-holder',
    description: 'Label for the account ownership when the customer is the co-holder',
  },
  [OwnershipType.ATTORNEY]: {
    id: 'widgets.bank_statements.account_ownership.ATTORNEY',
    defaultMessage: 'Attorney',
    description: 'Label for the account ownership when the customer is the attorney',
  },
  [OwnershipType.OTHER]: {
    id: 'widgets.bank_statements.account_ownership.OTHER',
    defaultMessage: 'N/A {icon}',
    description: 'Label for the account ownership when the ownership is not defined',
  },
  tooltip: {
    id: 'widgets.bank_statements.account_ownership.tooltip',
    defaultMessage: 'The ownership information could not be retrieved.',
    description: 'Tooltip message when no ownership type has been found or is unknown.',
  },
});
